(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("yox"));
	else if(typeof define === 'function' && define.amd)
		define("Bell", ["yox"], factory);
	else if(typeof exports === 'object')
		exports["Bell"] = factory(require("yox"));
	else
		root["Bell"] = factory(root["Yox"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 